export default __webpack_public_path__ + "static/media/1.82b4cd3d.jpg";